import React from 'react'
import { DEBT_WORK_STATUS_UNSIGNED_HINT, debtWorkStatusLabel } from './debtWorkStatus'

const DebtWorkStatusCell = ({ debt, canEdit, onOpen, tabIndex }) => {
  const label = debtWorkStatusLabel(debt?.workStatus)
  const open = () => onOpen?.(debt)
  const keepSpace = (event) => {
    if (event.key === ' ') event.stopPropagation()
  }

  if (label) {
    return (
      <button
        type="button"
        title="Open progress timeline"
        tabIndex={tabIndex}
        onClick={open}
        onKeyDown={keepSpace}
        className="px-2 py-0.5 rounded-full text-xs font-medium border border-divider hover:bg-surface"
      >
        {label}
      </button>
    )
  }

  if (debt?.isSigned !== true) {
    return <span title={DEBT_WORK_STATUS_UNSIGNED_HINT}>—</span>
  }

  if (canEdit) {
    return (
      <button
        type="button"
        aria-label="Add progress"
        tabIndex={tabIndex}
        onClick={open}
        onKeyDown={keepSpace}
        className="px-2 py-0.5 rounded-full text-xs font-medium border border-divider text-primary-main hover:bg-surface"
      >
        Add
      </button>
    )
  }

  return <span>—</span>
}

export default DebtWorkStatusCell
